import React, { useCallback, useState, useMemo } from 'react';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';

import { stringNormalize } from '../../../../../../util/stringNormalize';

import iconVariaveis from '../../../../../../assets/images/ic_variaveis.svg';

import { Wrapper, ContainerMenu, ContentMenu } from './styles';

const MenuVariaveisVoicebot = ({ onSelect, id }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { voicebotVariables } = useSelector((state) => state.voiceBot);

  const filteredVariables = useMemo(() => {
    if (!searchTerm) return voicebotVariables;

    const findVariables = voicebotVariables.filter((variable) => {
      const variableNameNormalized = stringNormalize(variable.DeIvrVariable);
      const variableCodeNormalized = stringNormalize(variable.CodeIvrVariable);
      const searchTermNormalized = stringNormalize(searchTerm);

      return (
        variableNameNormalized.includes(searchTermNormalized) ||
        variableCodeNormalized.includes(searchTermNormalized)
      );
    });

    return findVariables;
  }, [voicebotVariables, searchTerm]);

  const handleSelect = useCallback(
    (value) => {
      onSelect(value);
    },
    [onSelect]
  );

  return (
    <Wrapper>
      <button
        type="button"
        className="menu__button"
        data-tip
        data-for={id}
        data-event="click"
      >
        <img src={iconVariaveis} alt="Icon variável" />
      </button>

      <ReactTooltip
        id={id}
        effect="solid"
        place="bottom"
        className="container-tooltip"
        clickable
        globalEventOff="click"
        isCapture
        getContent={() => (
          <ContainerMenu>
            <ContentMenu>
              <h4>Variáveis do Fluxo</h4>

              <input
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Pesquisar"
              />

              <ul>
                {filteredVariables?.map(
                  ({ IdIvrVariable, CodeIvrVariable }) => (
                    <li
                      key={IdIvrVariable}
                      onClick={() => handleSelect(CodeIvrVariable)}
                    >
                      {CodeIvrVariable}
                    </li>
                  )
                )}
              </ul>
            </ContentMenu>
          </ContainerMenu>
        )}
      />
    </Wrapper>
  );
};

export default MenuVariaveisVoicebot;
